import { createContext } from "react";

/** A back call-to-action shown in the topbar's left slot. */
export interface TopbarBackLink {
  /** Route the back link points at. */
  to: string;
  /** Visible label, e.g. "Back to tools". */
  label: string;
}

/**
 * Holds the active back link (or null). The provider
 * (app/providers/TopbarBackProvider) owns the state; the Topbar reads it via
 * `useTopbarBackLink` and pages register one via `useTopbarBack`. Split from the
 * setter context so pages that only register a link never re-render when it
 * changes.
 */
export const TopbarBackContext = createContext<TopbarBackLink | null>(null);

export type SetTopbarBack = (link: TopbarBackLink | null) => void;

/** The stable setter, exposed separately so registering a link is render-cheap. */
export const TopbarBackSetContext = createContext<SetTopbarBack>(() => {});
